import React from 'react'
import { useSelector } from 'react-redux'
import {
  DataTable, Table, TableBody, TableCell, TableContainer,
  TableHead, TableHeader, TableRow, TableToolbar, TableToolbarContent,
  TableToolbarSearch, Button
} from '@carbon/react';
import { useSorting } from '../../../modules/hooks/sorting';

const PtoTable = _ => {
  const { data } = useSelector(state => state.pto)

  const headerData = [
    {
      header: 'Camión', // Corresponds to the truckPatent field
      key: 'truckPatent',
    },
    {
      header: 'ID Dispositivo', // Corresponds to the device_id field
      key: 'device_id',
    },
    {
      header: 'Ciclo Normal', // Corresponds to the ciclo_normal field
      key: 'ciclo_normal',
    },
    {
      header: 'Ciclo PTO', // Corresponds to the ciclo_pto field
      key: 'ciclo_pto',
    }
  ];

  const convertToCSV = (data) => {
    // Define the new headers and their mapping to the old ones
    const headerMapping = {
      truckPatent: 'Camión', // Maps truckPatent to Camión
      device_id: 'ID Dispositivo', // Maps device_id to ID Dispositivo
      ciclo_normal: 'Ciclo Normal', // Maps ciclo_normal to Ciclo Normal
      ciclo_pto: 'Ciclo PTO', // Maps ciclo_pto to Ciclo PTO
    };     

    if (data.length === 0) {
      return '';
    }

    const headers = Object.values(headerMapping).join(',') + '\n';

    const rows = data.map(row => {
      return Object.keys(headerMapping).map(key => {
        let value = row[key];
        // Check if the value is a number
        if (!isNaN(value) && value.toString().indexOf('.') !== -1) {
          // If it's a number with a dot, replace the dot with a comma
          value = value.toString().replace('.', ',');
        }
        return `"${value}"`; // Apply text formatting to all fields
      }).join(',');
    }).join('\n');

    return headers + rows;
  };

  const downloadCSV = (csvContent, fileName = 'download.csv') => {
    // Create a Blob with the CSV content
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    // Create a hidden link element
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);

    // Append link to the body, click it, and then remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownload = () => {
    const csv = convertToCSV(data);

    downloadCSV(csv, 'Diferencia Pto.csv');
  };
  
  const { rows, headers } = useSorting(data, headerData);

  const Default = () => (
    <DataTable rows={rows} headers={headers} width="100%">
      {({
        rows,
        headers,
        getHeaderProps,
        getRowProps,
        getTableProps,
        getTableContainerProps,
        onInputChange,
        sortBy,
      }) => (
        <TableContainer {...getTableContainerProps()}>
          <TableToolbar>
            <TableToolbarContent>
              <TableToolbarSearch onChange={onInputChange} />
              <Button onClick={handleDownload}>Descargar</Button>
            </TableToolbarContent>
          </TableToolbar>
          <Table {...getTableProps()} aria-label="sample table">
            <TableHead>
              <TableRow>
                {headers.map((header, i) => {
                  const { key: _unusedKey, ...headerProps } = getHeaderProps({
                    header,
                    isSortable:
                      (headerData[i]?.sortDirection ?? "NONE") !== "NONE",
                    onClick: (_, sortState) => sortBy(sortState.sortHeaderKey),
                  });
  
                  return (
                    <TableHeader
                      key={i}
                      sortDirection={headerData[i]?.sortDirection ?? "NONE"}
                      {...headerProps}
                    >
                      {header.header}
                    </TableHeader>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => {
                const { key: _unusedKey, ...rowProps } = getRowProps({ row });
  
                return (
                  <React.Fragment key={row.id}>
                    <TableRow {...rowProps}>
                      {row.cells.map((cell) => (
                        <TableCell key={cell.id}>{cell.value}</TableCell>
                      ))}
                    </TableRow>
                  </React.Fragment>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </DataTable>
  );  

  return (
    <Default />
  )
}

export default PtoTable;